import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import PrivateRoute from './components/dashboard/PrivateRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/materialdesignicons.css';
import './App.css';

// Lazy-load secondary and dashboard routes to keep landing page bundle ultra-light
const About = lazy(() => import('./pages/About'));
const Disclaimer = lazy(() => import('./pages/Disclaimer'));
const Help = lazy(() => import('./pages/Help'));
const DisclaimerAndPrivacyPolicy = lazy(() => import('./pages/Disclaimer-and-Privacy-Policy'));
const AdminSignup = lazy(() => import('./pages/AdminSignup'));
const OtpVerification = lazy(() => import('./pages/OtpVerification'));
const Signup = lazy(() => import('./pages/Signup'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const Forgotpassword = lazy(() => import('./pages/Forgotpassword'));
const Dashboard = lazy(() => import('./pages/Dashboard'));

// Minimal fallback spinner
const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
    <div className="spinner-border" role="status" style={{ color: '#9e6de0', width: '2.5rem', height: '2.5rem' }}>
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const App = () => {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate replace to="/login" />} />
          <Route path="*" element={<Navigate replace to="/login" />} />
          <Route path="/otp-verification" element={<OtpVerification />} />
          <Route path="/about" element={<About />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/help" element={<Help />} />
          <Route path="/disclaimer-and-privacy-policy" element={<DisclaimerAndPrivacyPolicy />} />
          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/signup" element={<Signup />} />      
          <Route path="/adminsignup" element={<AdminSignup />} />      
          
          {/* Protected Route for Dashboard */}
          <Route 
            path="/dashboard/*" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />       
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;

